import React from 'react';
import { AppMenuButtonMobile, AppMenuList, AppMenuListItem, ListIcon, units } from '@m/alchemy-ui';
import { Link } from 'react-location';
import { FormattedMessage } from 'react-intl';
import { usePageMetadata } from '../../../hooks';
import { RouteLink } from '../../../common/interfaces';
import * as Styled from '../Navigation.styled';
import { useRuntimeUser } from '../../../context';
import { CommunityLogo } from './CommunityLogo';

export const MobileMenu = ({ isLoggedIn, links }: { isLoggedIn: boolean; links?: RouteLink[] }) => {
  const { title } = usePageMetadata();
  const { displayName, avatar } = useRuntimeUser();

  return (
    <AppMenuButtonMobile
      attachedMobileMenuTo="left"
      dialogHeaderContent={
        <Link to="/">
          <CommunityLogo />
        </Link>
      }
      label={
        <Styled.AppMobileButtonLabel>
          <ListIcon style={{ marginRight: units(1.5) }} aria-hidden="true" />
          <span>{title}</span>
        </Styled.AppMobileButtonLabel>
      }
      overlay={({ setIsOpen }) => (
        <AppMenuList>
          {isLoggedIn && (
            <AppMenuListItem key="login">
              <Link
                to="user/ideastream"
                onClick={() => {
                  setIsOpen && setIsOpen(false);
                }}
              >
                {avatar ? (
                  <Styled.NavProfileImage src={avatar} alt={displayName} data-testid="UserAvatar" />
                ) : (
                  <Styled.UserIcon />
                )}
                <FormattedMessage id="My profile" defaultMessage="My Profile" />
              </Link>
            </AppMenuListItem>
          )}
          {links?.map(({ linkTitle, url }, index) => (
            <AppMenuListItem key={url}>
              <Link
                to={index === 0 ? '/' : url}
                onClick={() => {
                  setIsOpen && setIsOpen(false);
                }}
              >
                {linkTitle}
              </Link>
            </AppMenuListItem>
          ))}
        </AppMenuList>
      )}
    />
  );
};
